import { ICostEstimateDesktopSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { trackPriceHistoryNextClick as onClick } from '../tracking';

export function getValuation(offer: IOfferSchema, costEstimate?: ICostEstimateDesktopSchema | null) {
  if (!costEstimate || !costEstimate.calculatorLink) {
    return undefined;
  }

  const url = costEstimate.calculatorLink;
  const title =
    offer.dealType === 'sale' ? 'Рыночная цена квартиры по оценке Циан' : 'Арендная ставка квартиры по оценке Циан';

  return { url, title, onClick };
}
